import projectsAnim from "./projects";
import homeAnim from "./home";
import servicesAnim from "./services";
import productsAnim from "./products";
import contactAnim from "./contact";
import aboutAnim from "./about";

let projectsPage = document.querySelector("#projects");
if (projectsPage !== null) {
  projectsAnim.init();
}

let homePage = document.querySelector("#homepage");
if (homePage !== null) {
  homeAnim.init();
}

let servicesPage = document.querySelector("#services");
if (servicesPage !== null) {
  servicesAnim.init();
}


let productsPage = document.querySelector("#products");
if (productsPage !== null) {
  productsAnim.init();
}

let contactPage = document.querySelector("#contact");
if (contactPage !== null) {
  contactAnim.init();
}


let aboutPage = document.querySelector("#about");
if (aboutPage !== null) {
  aboutAnim.init();
}



const menu = document.querySelector(".menu-menu-main-container");
if (menu) {
  ScrollTrigger.create({
    trigger: menu,
    start: "top top",
    onEnter: () => menu.classList.add("is-fixed"),
    onLeaveBack: () => menu.classList.remove("is-fixed"),
  });
}




//menu
document.addEventListener("DOMContentLoaded", function () {
  /**
   * @param {HTMLElement} el
   * @param {string}      attr
   * @param {any}         value
   */
  const setAttr = (el, attr, value) => el.setAttribute(attr, value);

  /** @type {HTMLElement} */
  const topBar = document.querySelector(".top-bar");
  let bluebg = document.getElementById("blue-bg");
  let nav = document.querySelector(".mobile-menu-container");
  let navcontainer = document.querySelector(".menu-menu-main-container-mobile");
   let body = document.querySelector("body");

  if (topBar) {
    /** @type {HTMLElement} */
    const mobileButton = topBar.querySelector("button.menu-toggle");
    console.log(mobileButton);

    if (mobileButton) {
      mobileButton.addEventListener("click", function () {
        topBar.classList.toggle("toggled");
        mobileButton.classList.toggle("open");
        bluebg.classList.toggle("slide");
        nav.classList.toggle("show");
        navcontainer.classList.toggle("open");
        body.classList.toggle("noscroll");

        if (mobileButton.getAttribute("aria-expanded") === "true") {
          setAttr(mobileButton, "aria-expanded", "false");

          
        } else {
          setAttr(mobileButton, "aria-expanded", "true");

        }
      });
    }
  }
});